import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedEnumify, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DescriptionItem, LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { getNoteLinesFormatted } from '@mews-commander/utils';
import { getServiceOrderNote } from '@mews-commander/legacy-entities/src/ducks/serviceOrderNotes';
import { getNoteLabelEnumValue } from '../../PropertiesTab/NotesForm/utils';

const NotesListItem = ({ note }: $TSFixMe) => {
    if (!note.text) {
        return null;
    }

    return (
        <DescriptionItem
            vertical
            wrap
            stretchDefinition
            data-test-id="notes"
            term={
                <div>
                    <LocalizedText textKey={TextKey.Note} />
                    {UnicodeEntity.NoBreakSpace}
                    {UnicodeEntity.LeftParenthesis}
                    <LocalizedEnumify enumValue={getNoteLabelEnumValue(note)} />
                    {UnicodeEntity.RightParenthesis}
                    {UnicodeEntity.Comma}
                    {UnicodeEntity.NoBreakSpace}
                    <LocalizedDateTimeFromUtc utcString={note.createdUtc} />
                </div>
            }
            definition={getNoteLinesFormatted(note)}
        />
    );
};

export default connect(
    createStructuredSelector({
        note: (state: $TSFixMe, { noteId }: $TSFixMe) => getServiceOrderNote(state, { id: noteId }) || {},
    })
)(NotesListItem);
